(function() {
    'use strict';

    angular
        .module('virtuallibraryApp')
        .factory('MaterialFileSearch', MaterialFileSearch);

    MaterialFileSearch.$inject = ['$resource'];

    function MaterialFileSearch($resource) {
        var resourceUrl =  'api/_search/material-files/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();
